import React, { Component } from "react";
import { scopeBranches, onBranchScopeChange } from "../../../utils/branchScope";
import { Row, Col, Form, Button, Modal, Spinner } from "react-bootstrap";
import moment from "moment";
import ReactPlayer from "react-player";
import CardLessDataTable from "../datatables/CardLessDataTableWithSearch";
import DateBlock from "../home_bck/DateBlock";
import { THEME } from "./lectureLibraryConstants";
import { DELETE_LECTURE_VIDEO, GET_R2_PLAYBACK_URL, GET_CLASS_SUBJECTS_BY_ACADEMIC_YEAR } from "./lectureLibraryService";

// Helper Status Badge component
const StatusBadge = ({ active, labelActive, labelInactive }) => {
  return (
    <span
      className={`badge badge-pill ${active ? 'badge-success' : 'badge-warning'}`}
      style={{ padding: "4px 10px", fontSize: "11px", fontWeight: "700" }}
    >
      {active ? (labelActive || "Active") : (labelInactive || "Inactive")}
    </span>
  );
};

// Local CheckboxDropdown for Manage Filters (matches ExpenseDashboard)
class CheckboxDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
    this.ref = React.createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutside);
  }

  handleOutside = (e) => {
    if (this.ref.current && !this.ref.current.contains(e.target)) {
      this.setState({ open: false });
    }
  };

  toggle = (id) => {
    const { value, onChange } = this.props;
    const exists = value.includes(id);
    onChange(exists ? value.filter((v) => v !== id) : [...value, id]);
  };

  render() {
    const { options, value, placeholder, onChange } = this.props;
    const { open } = this.state;
    const label = value.length === 0
      ? placeholder
      : value.length === options.length
        ? `All (${options.length})`
        : value.length === 1
          ? options.find((o) => o.value === value[0])?.label || `${value.length} selected`
          : `${value.length} selected`;

    return (
      <div ref={this.ref} style={{ position: "relative" }}>
        <div
          onClick={() => this.setState({ open: !open })}
          style={{
            borderRadius: 8,
            border: "1.5px solid #e2e8f0",
            padding: "8px 12px",
            fontSize: "13px",
            color: value.length ? "#1f2937" : "#9ca3af",
            background: "#ffffff",
            cursor: "pointer",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            userSelect: "none",
            height: "38px"
          }}
        >
          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label}</span>
          <i className={`fal fa-chevron-${open ? "up" : "down"}`} style={{ fontSize: 11, color: "#9ca3af", flexShrink: 0, marginLeft: 6 }} />
        </div>

        {open && (
          <div
            style={{
              position: "absolute",
              top: "calc(100% + 4px)",
              left: 0,
              right: 0,
              background: "#fff",
              border: "1.5px solid #e2e8f0",
              borderRadius: 8,
              boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
              zIndex: 999,
              maxHeight: 200,
              overflowY: "auto"
            }}
          >
            {options.length === 0 ? (
              <div style={{ padding: "10px 14px", fontSize: 12, color: "#9ca3af" }}>No options</div>
            ) : (
              <>
                <div
                  onClick={() => onChange(value.length === options.length ? [] : options.map((o) => o.value))}
                  style={{
                    padding: "8px 12px",
                    fontSize: 12,
                    fontWeight: 700,
                    color: "#6366f1",
                    cursor: "pointer",
                    borderBottom: "1px solid #f3f4f6",
                    display: "flex",
                    alignItems: "center",
                    gap: 8
                  }}
                >
                  <input type="checkbox" readOnly checked={value.length === options.length} style={{ accentColor: "#6366f1" }} />
                  Select All
                </div>
                {options.map((o) => (
                  <div
                    key={o.value}
                    onClick={() => this.toggle(o.value)}
                    style={{
                      padding: "7px 12px",
                      fontSize: 13,
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      background: value.includes(o.value) ? "#f5f3ff" : "transparent",
                      borderBottom: "1px solid #f9fafb"
                    }}
                  >
                    <input type="checkbox" readOnly checked={value.includes(o.value)} style={{ accentColor: "#6366f1" }} />
                    <span style={{ color: value.includes(o.value) ? "#6d28d9" : "#374151", fontWeight: value.includes(o.value) ? 600 : 400 }}>{o.label}</span>
                  </div>
                ))}
              </>
            )}
          </div>
        )}
      </div>
    );
  }
}

class LectureManage extends Component {
  constructor(props) {
    super(props);

    // Initial Date Range: past 30 days
    const defaultStart = moment().subtract(30, "days").format("YYYY-MM-DD");
    const defaultEnd = moment().format("YYYY-MM-DD");

    this.state = {
      // Filters initialized to Select All
      // Mirrors the header's branch scope (NavbarOne); no branch picker on this page.
      branchSearch: scopeBranches(props.branches || []).map(b => b.id),
      classSearch: (() => {
        if (!props.branches || !props.classes) return [];
        const allowedClassIds = new Set();
        scopeBranches(props.branches).forEach(b => {
          if (b.sections) b.sections.forEach(s => allowedClassIds.add(String(s.class_id)));
        });
        return props.classes.filter(c => allowedClassIds.has(String(c.id))).map(c => c.id);
      })(),
      subjectSearch: props.subjects ? props.subjects.map(s => s.id) : [],
      lecturerSearch: props.lecturers ? props.lecturers.map(l => l.employeeId) : [],
      catSearch: props.categories ? props.categories.map(c => c.id) : [],
      subCatSearch: props.subcategories ? props.subcategories.map(s => s.id) : [],
      publishSearch: ["1", "0"],
      paidSearch: ["1", "0"],
      fromDate: defaultStart,
      toDate: defaultEnd,
      dateMode: "custom",

      // Video Player Modal State
      playerOpen: false,
      playerLoading: false,
      selectedVideo: null,
      playbackUrl: "",

      dynamicSubjects: [],
    };
  }

  componentDidMount() {
    if (this.state.classSearch.length > 0) {
      this.fetchSubjects(this.state.classSearch, true);
    }
    // Branch comes from the header (NavbarOne) — re-scope when it changes.
    this.offBranchScope = onBranchScopeChange(() =>
      this.handleBranchSearchChange(scopeBranches(this.props.branches || []).map(b => b.id)));
  }

  componentWillUnmount() {
    if (this.offBranchScope) this.offBranchScope();
  }

  fetchSubjects = async (classIdsArray, autoSelect = false) => {
    if (!classIdsArray || classIdsArray.length === 0 || !this.props.academicYearId) {
      this.setState({ dynamicSubjects: [], subjectSearch: [], lecturerSearch: [] });
      return;
    }
    try {
      const res = await this.props.client.query({
        query: GET_CLASS_SUBJECTS_BY_ACADEMIC_YEAR,
        variables: { 
          academic_year_id: parseInt(this.props.academicYearId),
          classIds: classIdsArray.join(","),
          institute_id: parseInt(this.props.instituteId)
        },
        fetchPolicy: "network-only",
      });
      const apiData = res.data?.getClassSubjectsByAcademicYear || [];
      // Combine all returned classes' subjects into a single unique list
      let combinedSubjects = [];
      let seenIds = new Set();
      
      apiData.forEach(data => {
        if (data.subject_ids) {
          const parseCsv = (val) => String(val || "").split(",").map((s) => s.trim()).filter(Boolean);
          const isCheckedValue = (value) => {
            if (value === true || value === 1) return true;
            const normalized = String(value ?? "").trim().toLowerCase();
            return normalized === "true" || normalized === "1";
          };

          const subjectIds = parseCsv(data.subject_ids);
          const subjectNames = parseCsv(data.subject_names);
          const checkedValues = parseCsv(data.checked);
          
          subjectIds.forEach((id, idx) => {
            const numId = parseInt(id, 10);
            const isChecked = checkedValues.length ? isCheckedValue(checkedValues[idx]) : false;
            if (isChecked && !seenIds.has(numId)) {
              seenIds.add(numId);
              combinedSubjects.push({ id: numId, subject: subjectNames[idx] || id });
            }
          });
        }
      });
      // Auto-selection logic for subjects and lecturers
      let nextSubjectSearch = this.state.subjectSearch;
      if (autoSelect) {
        nextSubjectSearch = combinedSubjects.map(s => s.id);
      } else {
        nextSubjectSearch = this.state.subjectSearch.filter(id => combinedSubjects.some(s => s.id === id));
      }

      // Filter available lecturers based on the valid subjects
      let availableLecturers = this.props.lecturers.filter(l => {
        if (l.subject_ids) {
          const ids = String(l.subject_ids).split(",").map(id => id.trim());
          return ids.some(id => nextSubjectSearch.includes(parseInt(id, 10)));
        }
        return false;
      });

      let nextLecturerSearch = this.state.lecturerSearch;
      if (autoSelect) {
        nextLecturerSearch = availableLecturers.map(l => l.employeeId);
      } else {
        nextLecturerSearch = this.state.lecturerSearch.filter(id => availableLecturers.some(l => l.employeeId === id));
      }

      this.setState({ 
        dynamicSubjects: combinedSubjects,
        subjectSearch: nextSubjectSearch,
        lecturerSearch: nextLecturerSearch
      });
    } catch (err) {
      console.warn("Could not query subjects dynamically.", err);
    }
  };

  handleBranchSearchChange = (val) => {
    const allowedClassIds = new Set();
    this.props.branches.filter(b => val.includes(b.id)).forEach(b => {
      if (b.sections) b.sections.forEach(s => allowedClassIds.add(String(s.class_id)));
    });
    const newClassSearch = this.props.classes.filter(c => allowedClassIds.has(String(c.id))).map(c => c.id);

    this.setState({ branchSearch: val, classSearch: newClassSearch }, () => {
      this.fetchSubjects(newClassSearch, true);
    });
  };

  handleClassSearchChange = (val) => {
    this.setState({ classSearch: val }, () => {
      this.fetchSubjects(val, true);
    });
  };

  handleSubjectSearchChange = (val) => {
    let availableLecturers = this.props.lecturers.filter(l => {
      if (l.subject_ids) {
        const ids = String(l.subject_ids).split(",").map(id => id.trim());
        return ids.some(id => val.includes(parseInt(id, 10)));
      }
      return false;
    });
    const nextLecturerSearch = availableLecturers.map(l => l.employeeId);

    this.setState({ subjectSearch: val, lecturerSearch: nextLecturerSearch });
  };

  handleCatSearchChange = (val) => {
    const availableSubCats = this.props.subcategories.filter(s => val.includes(s.video_category_id));
    this.setState({ catSearch: val, subCatSearch: availableSubCats.map(s => s.id) });
  };

  // ─── Filter Events ─────────────────────────────────────────────────────────

  handleDateBlockCallback = (startDate, endDate) => {
    this.setState({
      dateMode: "custom",
      fromDate: startDate.format("YYYY-MM-DD"),
      toDate: endDate.format("YYYY-MM-DD")
    });
  };

  // ─── Secure Video Player Controller (Cloudflare R2 Integration) ────────────

  openVideoPlayer = async (video) => {
    this.setState({
      playerOpen: true,
      selectedVideo: video,
      playbackUrl: "",
      playerLoading: true,
    });

    const isExternal = video.video_url.startsWith("http://") || video.video_url.startsWith("https://");

    if (isExternal) {
      this.setState({ playbackUrl: video.video_url, playerLoading: false });
    } else {
      // Generate temporary playback url via Cloudflare R2
      try {
        const res = await this.props.client.query({
          query: GET_R2_PLAYBACK_URL,
          variables: { r2_key: video.video_url },
          fetchPolicy: "network-only",
        });
        const playbackUrl = res.data?.getR2VideoPlaybackUrl?.playback_url;
        if (playbackUrl) {
          this.setState({ playbackUrl, playerLoading: false });
        } else {
          alert("Error: Playback URL was empty.");
          this.closeVideoPlayer();
        }
      } catch (err) {
        console.error("Failed to generate playback url", err);
        alert("Failed to secure playback link from bucket.");
        this.closeVideoPlayer();
      }
    }
  };

  closeVideoPlayer = () => {
    this.setState({
      playerOpen: false,
      selectedVideo: null,
      playbackUrl: "",
      playerLoading: false,
    });
  };

  // Custom Modal Header matching the Expense / Category masters
  renderModalHeader = (icon, title, onClose) => {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "14px",
          padding: "18px 22px",
          background: "linear-gradient(135deg, rgb(99, 102, 241), rgb(139, 92, 246))",
          color: "#fff",
        }}
      >
        <span
          style={{
            width: 40,
            height: 40,
            borderRadius: "11px",
            background: "rgba(255, 255, 255, 0.18)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "17px",
            flexShrink: 0,
          }}
        >
          <i className={icon} />
        </span>
        <span style={{ flex: 1, fontSize: "16px", fontWeight: 700, lineHeight: 1.25 }}>
          {title}
        </span>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          style={{
            background: "rgba(255, 255, 255, 0.18)",
            border: "none",
            color: "#fff",
            width: 32,
            height: 32,
            borderRadius: "9px",
            cursor: "pointer",
            fontSize: "15px",
            lineHeight: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <i className="fal fa-times" />
        </button>
      </div>
    );
  };

  // ─── CRUD Actions ──────────────────────────────────────────────────────────

  handleDelete = async (id, title) => {
    const { client, onUpdate } = this.props;
    if (!window.confirm(`Are you sure you want to delete Lecture "${title}"? This action cannot be undone.`)) {
      return;
    }

    try {
      await client.mutate({
        mutation: DELETE_LECTURE_VIDEO,
        variables: { id },
      });
      alert("Lecture deleted successfully!");
      if (onUpdate) onUpdate();
    } catch (err) {
      console.error(err);
      alert("Failed to delete lecture: " + err.message);
    }
  };

  // ─── Table Columns Configurations ──────────────────────────────────────────

  getTableColumns = () => {
    const { categories, subcategories, classes, lecturers, onEdit } = this.props;
    return [
      {
        dataField: "id",
        text: "#",
        formatter: (cell, row, rowIndex) => rowIndex + 1,
        sort: true,
        headerStyle: { width: "70px", textAlign: "center" },
        style: { textAlign: "center" },
      },
      {
        dataField: "title",
        text: "Lecture Title",
        sort: true,
        formatter: (cell) => (
          <span style={{ fontWeight: "700", color: THEME.text }}>{cell}</span>
        ),
      },
      {
        dataField: "video_category_id",
        text: "Category / Subcategory",
        sort: true,
        formatter: (cell, row) => {
          const cat = categories.find((c) => Number(c.id) === Number(row.video_category_id))?.video_category || "—";
          const sub = subcategories.find((s) => Number(s.id) === Number(row.video_sub_category_id))?.video_sub_category || "—";
          return (
            <div style={{ fontSize: "12px", lineHeight: "1.3" }}>
              <div style={{ fontWeight: "600", color: THEME.text }}>{cat}</div>
              <div style={{ color: THEME.textMuted }}>{sub}</div>
            </div>
          );
        },
      },
      {
        dataField: "class_id",
        text: "Class / Subject",
        sort: true,
        formatter: (cell, row) => {
          const cls = classes.find((c) => String(c.id) === String(row.class_id))?.class || "—";
          return (
            <div style={{ fontSize: "12px", lineHeight: "1.3" }}>
              <div style={{ fontWeight: "600", color: THEME.text }}>{cls}</div>
              <div style={{ color: THEME.textMuted }}>{row._subjectName}</div>
            </div>
          );
        },
      },
      {
        dataField: "lecturer_id",
        text: "Lecturer",
        sort: true,
        formatter: (cell, row) => {
          return row._lecturerName;
        },
      },
      {
        dataField: "video_date",
        text: "Date",
        sort: true,
        headerStyle: { width: "110px" },
        formatter: (cell) => {
          return cell ? moment(cell).format("DD MMM YYYY") : "—";
        },
      },
      {
        dataField: "paid_video",
        text: "Paid?",
        sort: true,
        headerStyle: { width: "90px", textAlign: "center" },
        style: { textAlign: "center" },
        formatter: (cell) => <StatusBadge active={cell === 1 || cell === true} labelActive="Paid" labelInactive="Free" />,
      },
      {
        dataField: "publish",
        text: "Publish",
        sort: true,
        headerStyle: { width: "90px", textAlign: "center" },
        style: { textAlign: "center" },
        formatter: (cell) => <StatusBadge active={cell === 1 || cell === true} labelActive="Published" labelInactive="Draft" />,
      },
      {
        dataField: "actions",
        text: "Actions",
        headerStyle: { width: "140px", textAlign: "center" },
        style: { textAlign: "center" },
        formatter: (cell, row) => (
          <div>
            <button
              onClick={() => this.openVideoPlayer(row)}
              style={{ background: "none", border: "none", color: "#10b981", marginRight: "12px", cursor: "pointer" }}
              title="Play Video"
            >
              <i className="fal fa-play" />
            </button>
            <button
              onClick={() => onEdit(row)}
              style={{ background: "none", border: "none", color: THEME.primary, marginRight: "12px", cursor: "pointer" }}
              title="Edit Lecture"
            >
              <i className="fal fa-edit" />
            </button>
            <button
              onClick={() => this.handleDelete(row.id, row.title)}
              style={{ background: "none", border: "none", color: THEME.danger, cursor: "pointer" }}
              title="Delete Lecture"
            >
              <i className="fal fa-trash-alt" />
            </button>
          </div>
        ),
      },
    ];
  };

  render() {
    const { videos, categories, subcategories, classes, lecturers, branches, subjects } = this.props;
    const {
      branchSearch,
      subjectSearch,
      catSearch,
      subCatSearch,
      classSearch,
      paidSearch,
      publishSearch,
      lecturerSearch,
      fromDate,
      toDate,
      playerOpen,
      playerLoading,
      selectedVideo,
      playbackUrl,
      playerPlaying,
      currentTime,
      videoDuration
    } = this.state;

    // Derived Filter Options matching hierarchy
    const branchOptions = branches.map((b) => ({ value: b.id, label: b.branch_name }));

    // Classes strictly filtered by selected branches
    let availableClasses = [];
    if (branchSearch.length > 0) {
      const allowedClassIds = new Set();
      branches.filter(b => branchSearch.includes(b.id)).forEach(b => {
        if (b.sections) b.sections.forEach(s => allowedClassIds.add(String(s.class_id)));
      });
      availableClasses = classes.filter(c => allowedClassIds.has(String(c.id)));
    }
    const classOptions = availableClasses.map((c) => ({ value: c.id, label: c.class }));

    // Subjects fetched from API
    const subjectOptions = this.state.dynamicSubjects.map((s) => ({ value: s.id, label: s.subject || `Subject ${s.id}` }));

    // Lecturers filtered by subjectSearch
    let availableLecturers = lecturers;
    if (subjectSearch.length > 0) {
      availableLecturers = lecturers.filter(l => {
        if (l.subject_ids) {
          const ids = String(l.subject_ids).split(",").map(id => id.trim());
          return ids.some(id => subjectSearch.includes(parseInt(id, 10)));
        }
        return false;
      });
    }
    const lecturerOptions = availableLecturers.map((l) => ({ value: l.employeeId, label: l.employee_name }));

    const catOptions = categories.map((c) => ({ value: c.id, label: c.video_category }));
    
    // Subcategories filtered by category
    let availableSubCats = subcategories;
    if (catSearch.length > 0 && catSearch.length < catOptions.length) {
      availableSubCats = subcategories.filter(s => catSearch.includes(s.video_category_id));
    }
    const subCatOptions = availableSubCats.map((s) => ({ value: s.id, label: s.video_sub_category }));
    const paidOptions = [{ value: "1", label: "Paid Only" }, { value: "0", label: "Free Only" }];
    const publishOptions = [{ value: "1", label: "Published" }, { value: "0", label: "Drafts" }];

    // Client-side filtration logic
    const filteredVideos = videos.filter((vid) => {
      // If none are selected, it should not populate (returns false)
      if (branchSearch.length === 0 || classSearch.length === 0 || subjectSearch.length === 0 || lecturerSearch.length === 0 || catSearch.length === 0 || subCatSearch.length === 0) {
        return false;
      }

      // If 'Select All' is checked (all available options are selected), skip the strict match check
      // to gracefully allow videos whose IDs might not be present in the loaded dropdown options.
      if (branchSearch.length < branchOptions.length) {
        const vidBranches = String(vid.branch_ids || "").split(",").map(s => s.trim());
        const hasBranchMatch = vidBranches.some(b => branchSearch.map(String).includes(b));
        if (!hasBranchMatch) {
          return false;
        }
      }

      if (classSearch.length < classOptions.length) {
        if (!classSearch.map(String).includes(String(vid.class_id))) return false;
      }
      
      if (subjectSearch.length < subjectOptions.length) {
        if (!subjectSearch.map(String).includes(String(vid.subject_id))) return false;
      }

      if (lecturerSearch.length < lecturerOptions.length) {
        if (!lecturerSearch.map(String).includes(String(vid.lecturer_id))) return false;
      }

      if (catSearch.length < catOptions.length) {
        if (!catSearch.map(String).includes(String(vid.video_category_id))) return false;
      }

      if (subCatSearch.length < subCatOptions.length) {
        if (!subCatSearch.map(String).includes(String(vid.video_sub_category_id))) return false;
      }

      const pStatus = vid.paid_video === 1 || vid.paid_video === true ? "1" : "0";
      if (paidSearch.length > 0 && !paidSearch.includes(pStatus)) {
        return false;
      }

      const pubStatus = vid.publish === 1 || vid.publish === true ? "1" : "0";
      if (publishSearch.length > 0 && !publishSearch.includes(pubStatus)) {
        return false;
      }

      // Date range filtering
      if (vid.video_date) {
        if (vid.video_date < fromDate || vid.video_date > toDate) {
          return false;
        }
      }

      return true;
    }).map(v => {
      // Pre-resolve dynamically fetched names here so the table's cached formatters don't miss state updates
      const sub = this.state.dynamicSubjects.find((s) => String(s.id) === String(v.subject_id))?.subject || this.props.subjects.find((s) => String(s.id) === String(v.subject_id))?.subject || "—";
      const lec = this.props.lecturers.find((l) => String(l.employeeId) === String(v.lecturer_id))?.employee_name || "—";
      return { ...v, _subjectName: sub, _lecturerName: lec };
    }).sort((a, b) => b.id - a.id);

    const seekPct = videoDuration ? (currentTime / videoDuration) * 100 : 0;

    return (
      <div style={{ padding: "8px 0" }}>
        {/* Date Filter Top Right */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "12px" }}>
          <div style={{ width: "300px" }}>
            <Form.Label style={{ fontSize: "11px", fontWeight: "700", color: THEME.textMuted, marginBottom: 5, display: "block" }}>
              Select Date Range
            </Form.Label>
            <DateBlock applyCallback={this.handleDateBlockCallback} leftMode={false} />
          </div>
        </div>

        {/* Filters Panel matching integrated light block in ExpenseDashboard */}
        <div style={{ background: "#f8fafc", borderRadius: 12, border: "1.5px solid #e2e8f0", marginBottom: "20px", padding: "18px 20px" }}>
          <Row className="g-3 align-items-end">
            {/* No Branch filter — the header (NavbarOne) scopes this library. */}
            <Col lg={2} md={4} sm={6} className="mb-2">
              <Form.Label style={{ fontSize: "11px", fontWeight: "700", color: THEME.textMuted, marginBottom: 5 }}>Class</Form.Label>
              <CheckboxDropdown options={classOptions} value={this.state.classSearch} onChange={this.handleClassSearchChange} placeholder="All Classes" />
            </Col>
            <Col lg={2} md={4} sm={6} className="mb-2">
              <Form.Label style={{ fontSize: "11px", fontWeight: "700", color: THEME.textMuted, marginBottom: 5 }}>Subject</Form.Label>
              <CheckboxDropdown options={subjectOptions} value={this.state.subjectSearch} onChange={this.handleSubjectSearchChange} placeholder="All Subjects" />
            </Col>
            <Col lg={2} md={4} sm={6} className="mb-2">
              <Form.Label style={{ fontSize: "11px", fontWeight: "700", color: THEME.textMuted, marginBottom: 5 }}>Lecturer</Form.Label>
              <CheckboxDropdown options={lecturerOptions} value={this.state.lecturerSearch} onChange={(val) => this.setState({ lecturerSearch: val })} placeholder="All Lecturers" />
            </Col>
            <Col lg={2} md={4} sm={6} className="mb-2">
              <Form.Label style={{ fontSize: "11px", fontWeight: "700", color: THEME.textMuted, marginBottom: 5 }}>Category</Form.Label>
              <CheckboxDropdown options={catOptions} value={this.state.catSearch} onChange={this.handleCatSearchChange} placeholder="All Categories" />
            </Col>
            <Col lg={2} md={4} sm={6} className="mb-2">
              <Form.Label style={{ fontSize: "11px", fontWeight: "700", color: THEME.textMuted, marginBottom: 5 }}>Sub Category</Form.Label>
              <CheckboxDropdown options={subCatOptions} value={this.state.subCatSearch} onChange={(val) => this.setState({ subCatSearch: val })} placeholder="All Sub Categories" />
            </Col>

            {/* Optional existing filters pushed down */}
            <Col lg={2} md={4} sm={6} className="mb-2">
              <Form.Label style={{ fontSize: "11px", fontWeight: "700", color: THEME.textMuted, marginBottom: 5 }}>Paid Status</Form.Label>
              <CheckboxDropdown options={paidOptions} value={this.state.paidSearch} onChange={(val) => this.setState({ paidSearch: val })} placeholder="Free & Paid" />
            </Col>
            <Col lg={2} md={4} sm={6} className="mb-2">
              <Form.Label style={{ fontSize: "11px", fontWeight: "700", color: THEME.textMuted, marginBottom: 5 }}>Publish Status</Form.Label>
              <CheckboxDropdown options={publishOptions} value={this.state.publishSearch} onChange={(val) => this.setState({ publishSearch: val })} placeholder="Draft & Published" />
            </Col>
          </Row>
        </div>

        {/* Datatable Wrapper */}
        <div style={{ background: "#ffffff", borderRadius: 12, padding: "2px" }}>
          <CardLessDataTable
            parentData={filteredVideos}
            particlecolumns={this.getTableColumns()}
            name="lectures_registry"
            searchBar={true}
            placeholder="Search Lecture Videos..."
          />
        </div>

        {/* Playback Modal Dialog */}
        <Modal show={playerOpen} onHide={this.closeVideoPlayer} size="lg" centered>
          {this.renderModalHeader(
            "fal fa-play-circle",
            selectedVideo ? selectedVideo.title : "Lecture Player",
            this.closeVideoPlayer
          )}
          <Modal.Body style={{ padding: "0", background: "#000", position: "relative", minHeight: "360px" }}>
            {playerLoading ? (
              <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: "360px", color: "#fff" }}>
                <Spinner animation="border" variant="light" className="mb-2" />
                <span>Generating secure stream playback link...</span>
              </div>
            ) : (
              <div style={{ position: "relative", background: "#000", width: "100%", paddingTop: "56.25%" /* 16:9 Aspect Ratio */ }}>
                <ReactPlayer
                  url={playbackUrl}
                  controls={true}
                  width="100%"
                  height="100%"
                  style={{ position: "absolute", top: 0, left: 0 }}
                  config={{
                    file: {
                      attributes: {
                        controlsList: "nodownload" // Prevent native download button
                      }
                    }
                  }}
                />
              </div>
            )}
          </Modal.Body>
          <Modal.Footer style={{ background: THEME.bgLight, borderTop: `1px solid ${THEME.border}`, padding: "10px 18px" }}>
            {selectedVideo && selectedVideo.doc_file && (
              <div className="mr-auto d-flex align-items-center">
                <i className="fas fa-file-pdf text-danger mr-2" />
                <a href={selectedVideo.doc_file} target="_blank" rel="noopener noreferrer" style={{ fontSize: "12px", fontWeight: "700", color: THEME.primary, textDecoration: "none" }}>
                  Download Lecture Notes
                </a>
              </div>
            )}
            <Button variant="secondary" size="sm" onClick={this.closeVideoPlayer} style={{ fontWeight: "700" }}>
              Close Player
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default LectureManage;
